import { Backdrop } from '@mui/material';
import { Gallery, GalleryItem } from '@zenput/feature-zencam';

type SimpleGalleryProps = {
    items: GalleryItem[];
    onClose: () => void;
    startIndex: number;
};

//I extracted this from zenput frontend, so when we change to the new app we wont need it
export const SimpleGallery = (props: SimpleGalleryProps) => {
    const { items, onClose, startIndex } = props;
    return (
        <Backdrop open sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'inherit' }}>
            <Gallery
                allowChanges={false}
                fetchMore={undefined}
                initialItems={items}
                onGoBack={onClose}
                startIndex={startIndex}
                totalCount={items.length}
            />
        </Backdrop>
    );
};
